import { render, staticRenderFns } from "./JobRequests.vue?vue&type=template&id=e494f614&"
import script from "./JobRequests.vue?vue&type=script&lang=js&"
export * from "./JobRequests.vue?vue&type=script&lang=js&"
import style0 from "./JobRequests.vue?vue&type=style&index=0&id=e494f614&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports